import { Link } from 'react-router-dom';

export default function SubscriptionCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
      <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900/85 border border-amber-500/40 rounded-2xl p-8 shadow-sm text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-amber-500/20 flex items-center justify-center mb-4">
            <svg className="h-6 w-6 text-amber-300" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.487 0l6.518 11.59c.75 1.334-.213 2.987-1.743 2.987H3.482c-1.53 0-2.493-1.653-1.743-2.987l6.518-11.59zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-8a1 1 0 00-.894.553l-.5 1a1 1 0 00.894 1.447h1a1 1 0 00.894-1.447l-.5-1A1 1 0 0010 5z" clipRule="evenodd" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-100">Subscription canceled</h1>
          <p className="text-slate-300 mt-2">
            Your checkout was canceled. You can try again anytime.
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <Link
              to="/subscription_plans"
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors duration-200"
            >
              Back to Plans
            </Link>
            <Link
              to="/"
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-slate-200 text-slate-900 hover:bg-slate-300 transition-colors duration-200"
            >
              Go Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
